import permissions from '../permissions'

const AUDITS = [
  {
    name: 'Visualizar',
    tag: permissions.AUDITS.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.AUDITS.MANAGE,
  },
  {
    name: 'Finalizar Auditoria',
    tag: permissions.AUDITS.FINALIZE,
  },
]

export default AUDITS
